// El backend manda DateOnly como "2026-03-12". Se formatea a mano en vez de
// pasar por Date, porque `new Date("2026-03-12")` la interpreta como UTC y en
// Chile puede mostrar el día anterior.

const MESES = [
  "ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic",
];

export function formatearFecha(iso: string | null | undefined): string {
  if (!iso) return "—";

  const partes = iso.slice(0, 10).split("-");
  if (partes.length !== 3) return iso;

  const [anio, mes, dia] = partes as [string, string, string];
  const indiceMes = Number(mes) - 1;
  const nombreMes = MESES[indiceMes] ?? mes;

  return `${Number(dia)} ${nombreMes} ${anio}`;
}

/** Para inputs type="date", que esperan exactamente aaaa-mm-dd. */
export function paraInputFecha(iso: string | null | undefined): string {
  return iso ? iso.slice(0, 10) : "";
}

/** Formatea bytes en KB o MB legibles. */
export function formatearBytes(bytes: number): string {
  if (bytes <= 0) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

